import {Component,OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'success-dialog',
    templateUrl: './success-dialog.component.html'
})

export class SuccessDialogComponent implements OnInit {

    message: string; // Property to hold the success message

    constructor(
      public dialogRef: MatDialogRef<SuccessDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      this.message = data.message; // Initialize the message from MAT_DIALOG_DATA
    }
  
    ngOnInit(): void {}
  
    closeDialog() {
      this.dialogRef.close(); // Function to close the dialog
    }
}